import React from "react";
import "./PaymentOption.scss";
import Accordian from "../../../components/Accordian/Accordian";

const PaymentOption = () => {
  return (
    <div className="payment-setting">
      <div className="container-wrapper">
        <div className="upper-list">
          <Accordian name={"Payment Methods"}></Accordian>
        </div>

        <div className="lower-list"></div>
      </div>
    </div>
  );
};

export default PaymentOption;
